import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { CompanyCreditInfo } from './models/companycreditinfo.model';

@Injectable()
export class CompanyCreditService {
  isLoading = new Subject<boolean>();
  currentCreditInfoChanged = new Subject<CompanyCreditInfo>();
  constructor() { }
  clearCurrentInfo(){
    this.currentCreditInfoChanged.next(null);
  }
  setIsLoading(isLoading: boolean){
    this.isLoading.next(isLoading);
  }
  setCurrentInfo(info: CompanyCreditInfo){
    this.currentCreditInfoChanged.next(info);
  }
}
